import { ECountry } from '@/shared/enum/country.enum'

export const hasClaroBalancer = (country: ECountry): boolean => {
  const countriesWithClaroBalancer = [ECountry.SV]
  return countriesWithClaroBalancer.includes(country)
}
